import { useContext, useEffect, useState } from "react";
import uploadFile from "../../util/uploadFile";
import Heading from "../UI/Heading";
import { AuthContext } from "../../context/auth-context";
import LoadingSpinner from "../UI/LoadingSpinner";
import { requestPartnerAPI } from "../../api/server";
import { UtilityContext } from "../../context/util-context";
import { MdClose } from "react-icons/md";

export default function RequestPayment() {
  const { user } = useContext(AuthContext);
  const { navigate } = useContext(UtilityContext);

  // Initialize States
  const [loading, setLoading] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [uploading, setUploading] = useState(false);

  // ======================== FETCH VEHICLES
  const fetchVehicles = async () => {
    try {
      setLoading(true);
      const response = await requestPartnerAPI("fetch-vehicles", {});
      setVehicles(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // ======================== ADD PAYMENT
  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const data = {
        amount: e.target.amount.value,
        description: e.target.description.value,
        vin: e.target.vehicle.value,
      };

      if (e.target.document.files[0]) {
        const path = `partners/${
          user.uid
        }/payments/${Date.now()}.${e.target.document.files[0].name
          .split(".")
          .pop()}`;
        data.document = await uploadFile(
          path,
          e.target.document.files[0],
          setUploading
        );
        setUploading(false);
      }

      const paymentId = await requestPartnerAPI("request-payment", data);
      navigate(`/payments`);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  return (
    <div className="container grid content-start gap-6">
      <Heading
        title="Request Payment"
        description={`Please make sure to select the vehicle pertaining 
        to the payment. You will receive a notification once the payment is approved.`}
      >
        <MdClose
          onClick={() => navigate("/payments")}
          className="icon"
        />
      </Heading>

      <form onSubmit={submitHandler} className="grid gap-8">
        <div className="grid gap-4 md:grid-cols-4">
          <div className="grid">
            <p className="form-label">Amount:</p>
            <input className="form-input" name="amount" required />
          </div>
          <div className="grid md:col-span-3">
            <p className="form-label">Description:</p>
            <input className="form-input" name="description" required />
          </div>
          <div className="grid md:col-span-2">
            <p className="form-label">Vehicle:</p>
            <select className="cursor-pointer form-input" name="vehicle">
              {vehicles?.map((vehicle, idx) => {
                if (vehicle.onboarded)
                  return (
                    <option key={idx} value={vehicle.vin}>
                      {vehicle.year} {vehicle.make} {vehicle.model} - {vehicle.vin?.substring(13, 17)}
                    </option>
                  );
              })}
            </select>
          </div>
          <div className="grid md:col-span-2">
            <p className="form-label">Documentation:</p>
            <input
              className="form-input"
              name="document"
              type="file"
              required
            />
          </div>
        </div>

        <div className="grid items-center gap-4 md:grid-cols-3">
          {loading ? (
            <LoadingSpinner />
          ) : (
            <button className="btn-primary" type="submit">
              Submit
            </button>
          )}
          {uploading && (
            <p className="text-stone-400">
              Uploading Documentation: {uploading}%
            </p>
          )}
        </div>
      </form>
    </div>
  );
}
